import { PAGE_TYPE } from '@utils/constants';
import injectorServer from '@src/pages/common/injectorServer';
import { TempAlertDiagnostics } from './temp';

export const AlertDiagnostics = injectorServer(
  {},
  { pageType: PAGE_TYPE.TEMP_DASHBOARD },
)(TempAlertDiagnostics);

export { PreManualAlertDiagnostics } from './pre';
